<template>
	<div class="content_hid table">
		<div class="d_font">
			<span class="g-fr btn_link" @click="clearColumn">清除</span>
			<label class="lbl">设置跳转地址：</label>
			<input v-if="level==1" class="txt" type="text" readonly="readonly" v-model="itemMdata.oneColumnId" />
			<input v-if="level==2" class="txt" type="text" readonly="readonly" v-model="itemMdata.twoColumnId" />
			<input v-if="level==3" class="txt" type="text" readonly="readonly" v-model="itemMdata.thirdColumnId" />
			<input v-if="!level" class="txt" type="text" readonly="readonly" v-model="itemMdata.link||itemMdata.columnId||itemMdata.artId" />
			<span @click="linkEdit(linkObj)" class="btn_link">修改链接</span>
		</div>
		<uiLink :itemMdata='itemImge' @closeArtD="closeArtD" @setLink="setLink" :editDial="editDial"></uiLink>
	</div>
</template>

<script>
	import api from '@/api/$ajax.js'
	import uiLink from '@/components/t1/m/uiLink.vue'
	export default {
		name: 'selectBgMode',
		components: {
			uiLink
		},
		created() {

		},
		props: ['itemMdata', 'type', 'level'],
		mounted() {
			let ts = this;			
		},
		methods: {
			setLink(data) {
				let ts = this;
				let type = "searchProduct";
				ts.itemMdata.columnId = String(data.link);
				ts.itemMdata.artId = String(data.artId);
				ts.itemMdata.link = String(data.link);
				ts.itemMdata.target = data.target;
				// debugger
				if(ts.level == 1) {
					ts.itemMdata.oneColumnId = String(data.link);
					ts.itemMdata.oneLevel = 2;
					api.get('/api/data/bindCategoryLink?column_id=' + ts.itemMdata.oneColumnId + "&category_id=" + ts.$route.query.company_id + ts.level + "&searchType=productList",
						false, {},
						function(r) {
							if(r.code == 422) {
								return;
							}
						}
					);

				} else if(ts.level == 2) {
					ts.itemMdata.twoLevel = 2;
					ts.itemMdata.twoColumnId = String(data.link);
					api.get('/api/data/bindCategoryLink?column_id=' + ts.itemMdata.twoColumnId + "&category_id=" + ts.$route.query.company_id + ts.level + "&searchType=productList",
						false, {},
						function(r) {
							if(r.code == 422) {
								return;
							}
						}
					);

				} else if(ts.level == 3) {
					ts.itemMdata.thirdLevel = 2;
					ts.itemMdata.thirdColumnId = String(data.link);
					api.get('/api/data/bindCategoryLink?column_id=' + ts.itemMdata.thirdColumnId + "&category_id=" + ts.$route.query.company_id + ts.level + "&searchType=productList",
						false, {},
						function(r) {
							if(r.code == 422) {
								return;
							}
						}
					);

				} else if(ts.type == "searchProduct") {

					if(ts.itemMdata.content_hid) {
						type = "searchAll";
					}

					api.get('/api/data/bindCategoryLink?column_id=' + ts.itemMdata.columnId + "&category_id=" + ts.$route.query.company_id + "&searchType=" + type,
						false, {},
						function(r) {
							if(r.code == 422) {
								return;
							}
						}
					);
				}

			},
			linkEdit() {
				let ts = this;
				ts.editDial.setlink = true;
			},
			calArtpos(el) {
				if(!el) {
					return;
				}
				// 获取可见窗口大小
				var bodyW = document.documentElement.clientWidth;
				var bodyH = document.documentElement.clientHeight;
				// 获取对话框宽、高		
				var elW = el.offsetWidth;
				var elH = el.offsetHeight || el.clientHeight;
				// debugger
				el.style.left = (bodyW - elW) / 2 + 'px';
				el.style.top = (bodyH - elH) / 2 + 'px';
			},
			closeArtD() {
				let ts = this;
				ts.editDial.setlink = false;
				//debugger
			},
			clearColumn() {
				let ts = this;
				ts.itemMdata.columnId = '';
				ts.itemMdata.link = '';
				ts.itemMdata.artId = '';
				let type = "searchProduct";
				if(ts.itemMdata.content_hid) {
					type = "searchAll";
				}
				if(ts.level) {

					type = "productList";
					if(ts.level == 1) {
						ts.itemMdata.oneColumnId = "";
					} else if(ts.level == 2) {
						ts.itemMdata.twoColumnId = "";
					} else if(ts.level == 3) {
						ts.itemMdata.thirdColumnId = "";
					}

					api.get('/api/data/bindCategoryLink?column_id=0' + "&category_id=" + ts.level,
						false, {},
						function(r) {
							if(r.code == 422) {
								return;
							}
						}
					);

				} else if(ts.type == "searchProduct") {
					api.get('/api/data/bindCategoryLink?column_id=0' + "&category_id=" + ts.$route.query.company_id,
						false, {},
						function(r) {
							if(r.code == 422) {
								return;
							}
						}
					);
				}

			}
		},
		data() {
			return {
				title: '设置跳转链接',
				linkObj: {
					url: "",
					artId: ""
				},
				itemImge: {
					link: ""
				},
				editDial: {
					artTitle: "设置链接地址",
					setlink: false
				},
				param: {
					id: this.$route.params.id,
					company_id: this.$route.query.company_id,
					token: this.$route.query.token,
					type: this.$route.query.type,
					lang: this.$route.query.lang,
					pc_version_id: this.$route.query.pc_version_id,
					version_id: this.$route.query.pc_version_id
				}
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.d_font {
		margin-top: 10px;
		.txt {
			height: 27px;
			width: 45%;
			border: 1px solid #ccc;
			line-height: 27px;
		}
		.btn_link {
			margin-left: 10px;
			cursor: pointer;
			border-radius: 4px;
			padding: 5px 7px;
			border: 1px solid #ccc;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/m/setLink.vue